<template>
    <div class="header-div">
        <gift-cert-icon class="h-12 w-12" />
        <div class="title-section">
            <div class="title-wrapper">
                <p>Purchase Gift Certificate</p>
            </div>
            <p>Purchase a gift certificate for a friend or family member.</p>
        </div>
        <XMarkIcon class="x-icon" @click="close" />
    </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import GiftCertIcon from '~/assets/images/icons/gift-cert-icon.svg';

const emit = defineEmits(['closeDialog']);

const close = () => {
    emit('closeDialog');
};
</script>
<style lang="scss" scoped>
.header-div {
    @apply flex flex-row items-start gap-4 self-stretch ;
}
.title-section {
    @apply flex flex-col items-start gap-1 flex-1 relative;

    p {
        @apply text-zinc-600 font-inter text-sm font-normal leading-5;
    }
}
.title-wrapper {
    @apply self-stretch flex flex-row justify-between;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.x-icon {
    @apply w-5 h-5 cursor-pointer top-0 right-0;
}
</style>
